import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  class: "arrow",
  style: {"width":"20px","height":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "a1",
    d: "M0 8 L10 1 L20 8"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "a2",
    d: "M0 14 L10 7 L20 14"
  })
], -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "d-block color-regular" }, " Plantillas ", -1)
const _hoisted_4 = { class: "el-dropdown-link can-hover" }
const _hoisted_5 = { class: "text-primary" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Todos ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exchange-alt transitioned" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-up" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-down" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]

import { computed, watch, onMounted, reactive, ref } from "vue";
import { ConversationModule } from "@/store/modules/Conversation";
import { TemplateModule } from "@/store/modules/Template";
import { ArrowDown } from "@element-plus/icons";
import TemplateComponent from "./template.vue";
import Loader from "./loader.vue";
import Form from "./form.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const names = computed(() => TemplateModule.templates.map(([key]) => key));
const templates = computed(() =>
	TemplateModule.templates.map(([, arrTemp]) => arrTemp)
);
const carousel = ref<any>(null);
const cursor = reactive({
	actual: 0,
	active: true,
});
watch(
	() => TemplateModule.category,
	() => {
		cursor.actual = 0;
		TemplateModule.setFilter({ actual: names.value[cursor.actual] });
		if (carousel.value) carousel.value.setActiveItem(cursor.actual.toString());
	}
);
function next() {
	carousel.value.next();
	cursor.actual =
		cursor.actual === names.value.length - 1 ? 0 : cursor.actual + 1;
	TemplateModule.setFilter({
		actual: names.value[cursor.actual],
	});
}
function prev() {
	carousel.value.prev();
	cursor.actual =
		cursor.actual === 0 ? names.value.length - 1 : cursor.actual - 1;
	TemplateModule.setFilter({
		actual: names.value[cursor.actual],
	});
}
function toggleList() {
	cursor.active = !cursor.active;
}
onMounted(async () => {
	await TemplateModule.fetch();
	if (carousel.value) {
		carousel.value.setActiveItem(cursor.actual.toString());
		TemplateModule.setFilter({
			actual: templates.value[0]?.[0]?.name,
		});
	}
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { class: "my-2 control-templates up-control" }, {
    default: _withCtx(() => [
      _createElementVNode("button", {
        class: _normalizeClass(["up-button can-hover border-0 bg-none", { 'd-none': !_unref(cursor).active }]),
        onClick: toggleList
      }, _hoisted_2, 2),
      _createVNode(_component_el_row, { class: "bg-white" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, {
            class: "w-100",
            span: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 12,
                class: "d-flex align-items-center"
              }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _createVNode(_component_el_dropdown, {
                    trigger: "click",
                    class: "ml-auto mr-4"
                  }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_dropdown_item, {
                            disabled: !_unref(TemplateModule).category,
                            onClick: _cache[0] || (_cache[0] = () => _unref(TemplateModule).setCategory(''))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          }, 8, ["disabled"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TemplateModule).categories, (category) => {
                            return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                              onClick: () => _unref(TemplateModule).setCategory(category),
                              disabled: _unref(TemplateModule).category === category,
                              key: category
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(category), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick", "disabled"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(TemplateModule).category ? _unref(TemplateModule).category : "Todos"), 1),
                        _createElementVNode("span", null, [
                          _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ArrowDown))
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 12,
                class: "d-flex justify-content-end"
              }, {
                default: _withCtx(() => [
                  (_unref(ConversationModule).showToggle)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-sm btn-icon bg-none border-0",
                        onClick: _cache[1] || (_cache[1] = () => _unref(ConversationModule).setActive(false))
                      }, _hoisted_8))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-icon bg-none border-0",
                    onClick: toggleList
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fas fa-thumbtack transitioned", { 'rotate-45': !_unref(cursor).active }])
                    }, null, 2)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_unref(cursor).active)
            ? (_openBlock(), _createBlock(_component_el_col, {
                key: 0,
                span: 12
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    (_unref(TemplateModule).loading)
                      ? (_openBlock(), _createBlock(Loader, { key: 0 }))
                      : (_openBlock(), _createBlock(_component_el_carousel, {
                          key: 1,
                          ref_key: "carousel",
                          ref: carousel,
                          direction: "vertical",
                          autoplay: false,
                          class: "carousel-templates",
                          trigger: "click",
                          "indicator-position": "outside"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templates), (nameTemplates, index) => {
                              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                                key: index,
                                name: `${index}`
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(TemplateComponent, {
                                    templates: nameTemplates,
                                    "active-scrollbar": ""
                                  }, null, 8, ["templates"])
                                ]),
                                _: 2
                              }, 1032, ["name"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 512)),
                    _createElementVNode("div", {
                      style: {"height":"100%"},
                      class: "d-flex flex-column mx-1"
                    }, [
                      _createElementVNode("button", {
                        class: "btn-white border-0 rounded my-2 text-gray",
                        onClick: prev
                      }, _hoisted_11),
                      _createElementVNode("button", {
                        class: "btn-white border-0 my-2 rounded text-gray",
                        onClick: next
                      }, _hoisted_13)
                    ])
                  ])
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_el_col, {
                key: 1,
                span: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_scrollbar, { class: "list-templates px-2" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templates), (categoryTemplates, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          _createVNode(TemplateComponent, { templates: categoryTemplates }, null, 8, ["templates"])
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              (!_unref(TemplateModule).loading)
                ? (_openBlock(), _createBlock(Form, {
                    key: 0,
                    template: 
						_unref(TemplateModule).rawTemplates?.[_unref(TemplateModule).filters.actual]?.find(
							t => t.language === _unref(TemplateModule).filters.language
						) ??
							_unref(TemplateModule).rawTemplates?.[_unref(TemplateModule).filters.actual]?.[0]
					,
                    "active-scrollbar": _unref(cursor).active,
                    onTemplateSended: _cache[2] || (_cache[2] = () => (!_unref(cursor).active ? toggleList() : undefined))
                  }, null, 8, ["template", "active-scrollbar"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})